import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
const PaginationButton = (props) => {
    return _jsx("button", { className: classNames("uxpcore_pagination__button", {
            'uxpcore_pagination__button--selected': props.hasSelected,
            'uxpcore_pagination__button--disabled': props.disabled,
        }), disabled: props.disabled, onClick: e => {
            e.preventDefault();
            e.stopPropagation();
            props.onClick();
        }, children: props.children });
};
export default PaginationButton;
